import { FC } from 'react'
import VirtualStampNumber from '../../../../calculations/components/calculation-form/components/other/virtual-stamp-number'
import Shipment from '../../../../../types/api/shipment'

interface StampTubeCellProps {
    shipment?: Shipment
}

const StampTubeCell: FC<StampTubeCellProps> = ({ shipment }) => {
    if (!shipment) return <>—</>

    if (shipment.withoutCutting) {
        return <VirtualStampNumber data={shipment} />
    }

    return <>{shipment.stamp?.tube?.number || 'нет'}</>
}

export default StampTubeCell
